import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FormGroup, Label } from "reactstrap";
import { rawCountries } from "../../constant";

const PhoneNumberField = ({
  label = "Phone Number",
  phoneValue,
  countryCode,
  name = "phone_number",
  onChange,
  onBlur,
  required = false,
}) => {
  console.log("🚀 ~ PhoneNumberField.jsx:15 ~ countryCode:", countryCode);
  const getIsoFromDial = (dialCodeWithPlus) => {
    if (!dialCodeWithPlus) return "it";

    const dialCode = dialCodeWithPlus.replace("+", "");

    const matched = rawCountries.find((entry) => {
      const code = entry[1];
      return code === dialCode;
    });

    return matched ? matched[0] : "it";
  };

  return (
    <FormGroup>
      <Label for={name} className="passwordLabel">
        {label} {required && <span className="text-danger">*</span>}
      </Label>

      <PhoneInput
        country={getIsoFromDial(countryCode)}
        value={`${phoneValue}`}
        onChange={(phone, country) => {
          const dialCode = country?.dialCode || "";
          let nationalNumber = phone;

          onChange(nationalNumber || "", dialCode ? "+" + dialCode : "");
        }}
        inputClass="phoneInput"
        inputProps={{
          name,
          required,
          onBlur,
        }}
      />
    </FormGroup>
  );
};

export default PhoneNumberField;
